import * as R from 'ramda';

export const groupsSelector = state => ({
  loading: state.groups.loading,
  errorMessage: state.groups.error.message,
  groups: R.sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1), R.values(state.groups.groups)),
  modalOpen: state.groups.modalOpen,
  organization: state.organizations.organizations,
});
